import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	pending: {
		id: 'eoc.heartbeats.status-lozenge.pending.no-translate',
		defaultMessage: 'Pending',
		description: 'Lozenge text to indicate pending status of a heartbeat.',
	},
	pendingTooltip: {
		id: 'eoc.heartbeats.status-lozenge.pending-tooltip.no-translate',
		defaultMessage: 'Heartbeat is awaiting a response.',
		description: 'Tooltip text for pending status of a heartbeat.',
	},
	responsive: {
		id: 'eoc.heartbeats.status-lozenge.responsive.no-translate',
		defaultMessage: 'Responsive',
		description: 'Lozenge text to indicate responsive status of a heartbeat.',
	},
	responsiveTooltip: {
		id: 'eoc.heartbeats.status-lozenge.responsive-tooltip.no-translate',
		defaultMessage: 'Heartbeat has received a ping within the interval',
		description: 'Tooltip text for responsive status of a heartbeat.',
	},
	unresponsive: {
		id: 'eoc.heartbeats.status-lozenge.unresponsive.no-translate',
		defaultMessage: 'Unresponsive',
		description: 'Lozenge text to indicate unresponsive status of a heartbeat.',
	},
	unresponsiveTooltip: {
		id: 'eoc.heartbeats.status-lozenge.unresponsive-tooltip.no-translate',
		defaultMessage: 'Heartbeat didn’t receive a ping within the interval',
		description: 'Tooltip text for unresponsive status of a heartbeat.',
	},
	off: {
		id: 'eoc.heartbeats.status-lozenge.off.no-translate',
		defaultMessage: 'Off',
		description: 'Lozenge text to indicate off status of a heartbeat.',
	},
	offTooltip: {
		id: 'eoc.heartbeats.status-lozenge.off-tooltip.no-translate',
		defaultMessage: 'Heartbeat is turned off',
		description: 'Tooltip text for off status of a heartbeat.',
	},
});

export default messages;
